module.exports = __webpack_public_path__ + "media/transport_protocols/WorkPickup-5e07df66.svg";